import React from 'react'
import SideBar from '@components/JiaMeng/SideBar'

export default () => {
  return (
    <SideBar>
      <div style={{ color: '#333' }}>优惠券有什么玩法</div>
      <div style={{ color: '#666', marginTop: 10 }}>
        优惠券放在店铺和套餐首页，用优惠吸引用户领取
        也可以在私信中给有意向的信新人发放专享的大额优惠券，促进最终成交
      </div>
    </SideBar>
  )
}
